var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroovegateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.29,0l-89.29,89.28-40,40V0H0v440h210.71l89.29-89.28,40-40v129.28h580V0h-210.71ZM820,340h-380v-200H140v100h129.28l-99.99,100h-69.29V100h380v200h300v-100h-129.28l99.99-100h69.29v240Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroovegateLogo);
export default __webpack_public_path__ + "static/media/groovegate_logo.a9a6a8552166fdc04a3cb83cdbff611e.svg";
export { ForwardRef as ReactComponent };